module.exports = __webpack_public_path__ + "static/img/xm_foxue.22ebc1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xm/xm_foxue.png
// module id = 431
// module chunks = 0